import React, { useState } from "react";
import { Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import StadiumRoundedIcon from "@mui/icons-material/StadiumRounded";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { STADIUMS, Stadium } from "./stadiums";
import "./stadiumGrid.scss";

/** Responsive grid of WC 2026 host-stadium cards. Used by the desktop
 *  "WorldCup Info" tab and the mobile Fixtures "Info" segment. */
const StadiumGrid: React.FC = () => (
  <div className="stadiumGrid">
    {STADIUMS.map((stadium) => (
      <StadiumCard key={stadium.id} stadium={stadium} />
    ))}
  </div>
);

const StadiumCard: React.FC<{ stadium: Stadium }> = ({ stadium }) => (
  <Card className="stadiumCard">
    <StadiumImage id={stadium.id} name={stadium.name} />
    <CardContent>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Typography variant="h6" fontWeight={700} noWrap title={stadium.name}>
          {stadium.name}
        </Typography>
        <Chip label={stadium.country} size="small" color="primary" />
      </Stack>

      <Stack direction="row" alignItems="center" spacing={0.5} className="stadiumCard__meta">
        <PlaceOutlinedIcon fontSize="small" />
        <Typography variant="body2">{stadium.city}</Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1} className="stadiumCard__chips">
        <Chip
          size="small"
          variant="outlined"
          icon={<GroupsOutlinedIcon />}
          label={`${stadium.capacity.toLocaleString("en-US")} seats`}
        />
        {stadium.notable && (
          <Chip size="small" color="secondary" icon={<StarRoundedIcon />} label={stadium.notable} />
        )}
      </Stack>
    </CardContent>
  </Card>
);

const StadiumImage: React.FC<{ id: string; name: string }> = ({ id, name }) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className="stadiumCard__image stadiumCard__image--placeholder">
        <StadiumRoundedIcon />
      </div>
    );
  }

  return (
    <img
      className="stadiumCard__image"
      src={`/images/stadiums/${id}.jpg`}
      alt={name}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
};

export default StadiumGrid;
